export const BOOKSY_URL =
    "https://booksy.com/es-es/162278_auto-lavado-coche-reydetailing_servicios-profesionales_42471_leon";
export const PHONE_TEL = "tel:+34631480093";
export const PHONE_DISPLAY = "+34 631 48 00 93";
export const INSTAGRAM_URL = "https://www.instagram.com/rey_detailing_1/";
export const INSTAGRAM_HANDLE = "@rey_detailing_1";
export const ADDRESS = "C. Francisco Fernández Diez, 17, 24009 León";
export const MAPS_EMBED =
    "https://www.google.com/maps?q=C.+Francisco+Fern%C3%A1ndez+D%C3%ADez+17,+24009+Le%C3%B3n,+Spain&output=embed";

export const HERO_IMAGE =
    "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxnbG9zc3klMjBibGFjayUyMGNhciUyMHN0dWRpbyUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4Njk2NTk1N3ww&ixlib=rb-4.1.0&q=85";

export const SERVICES = [
    { id: "basico-express", name: "Básico", price: "15,00€", duration: "30 min" },
    { id: "premium", name: "Premium", price: "50,00€", duration: "2h 30min" },
    { id: "interior-basico", name: "Limpieza interior básico", price: "20,00€", duration: "1h" },
    { id: "interior-premium", name: "Limpieza interior premium", price: "25,00€", duration: "1h" },
    {
        id: "tapiceria-completa",
        name: "Tapicería completa",
        price: "120,00€",
        duration: "5h 30min",
        note: "El precio definitivo se dará el día de la cita ya que hay que ver el coche antes. La hora de entrega dependerá de lo que tarde la tapicería en secar.",
    },
    { id: "basico-completo", name: "Básico", price: "30,00€", duration: "1h 30min" },
    { id: "pulido-faros", name: "Pulido de faros", price: "50,00€", duration: "2h" },
    { id: "ozono", name: "Ozono", price: "20,00€", duration: "30 min" },
    { id: "limpieza-moto", name: "Limpieza moto", price: "20,00€", duration: "30 min" },
    { id: "anti-lluvia", name: "Anti-lluvia", price: "20,00€", duration: "30 min" },
    { id: "pack-detailing", name: "Pack completo detailing", price: "200,00€", duration: "8h 30min" },
];

export const REVIEWS = [
    {
        id: "review-1",
        text: "Cumple con las expectativas, tenía el coche lleno de mosquitos y de venir de la playa, ha quedado bien limpio, interior y exterior y a un precio muy competitivo, repetiré",
    },
    {
        id: "review-2",
        text: "Buen servicio con precio competitivo, llevé mi coche de 8 años muy sucio y lo han dejado como recién salido del concesionario. Volveré",
    },
    {
        id: "review-3",
        text: "Muy contento con el resultado, ni rastro de mosquitos ni sus marcas, una limpieza por dentro y por fuera de muy buena calidad y económica, repetiremos seguro",
    },
];

export const HOURS = [
    { day: "Lunes", time: "10:00–14:30 · 16:30–20:30" },
    { day: "Martes", time: "10:00–14:30 · 16:30–20:30" },
    { day: "Miércoles", time: "10:00–14:30 · 16:30–20:30" },
    { day: "Jueves", time: "10:00–14:30 · 16:30–20:30" },
    { day: "Viernes", time: "10:00–14:30 · 16:30–20:30" },
    { day: "Sábado", time: "10:00–18:00" },
    { day: "Domingo", time: "Cerrado" },
];

export const INSTAGRAM_IMAGES = [
    "/instagram/ig-1.jpg",
    "/instagram/ig-2.jpg",
    "/instagram/ig-3.jpg",
    "/instagram/ig-4.jpg",
    "/instagram/ig-5.jpg",
    "/instagram/ig-6.jpg",
];

export const NAV_LINKS = [
    { label: "Servicios", href: "#servicios", testId: "nav-link-servicios" },
    { label: "Ubicación", href: "#ubicacion", testId: "nav-link-ubicacion" },
    { label: "Reseñas", href: "#resenas", testId: "nav-link-resenas" },
    { label: "Instagram", href: "#instagram", testId: "nav-link-instagram" },
];

export const WHATSAPP_URL =
    "https://wa.me/34631480093?text=Hola%2C%20me%20gustar%C3%ADa%20reservar%20una%20cita";

export const BEFORE_AFTER = [
    {
        id: "llantas",
        title: "Limpieza y abrillantado de llantas",
        before: "/gallery/llantas-antes.jpg",
        after: "/gallery/llantas-despues.jpg",
    },
    {
        id: "mercedes",
        title: "Lavado exterior premium — Mercedes",
        before: "/gallery/mercedes-antes.jpg",
        after: "/gallery/mercedes-despues.jpg",
    },
    {
        id: "golf",
        title: "Lavado exterior completo — Volkswagen Golf",
        before: "/gallery/golf-antes.jpg",
        after: "/gallery/golf-despues.jpg",
    },
];
